import { IconButtonOperation, SousTitreButtonOperation, TitreButtonOperation } from '@/components/Dico';

import styles from './styles.module.css';

type Props = {
  icon: keyof typeof IconButtonOperation;
  iconFleche: keyof typeof IconButtonOperation;
  titre: keyof typeof TitreButtonOperation;
  sousTitre: keyof typeof SousTitreButtonOperation;
  onClick?: () => void;
};

const ButtonOperation = ({ icon, iconFleche, titre, sousTitre, onClick }: Props) => {
  return (
    <button className={styles.boxButton} onClick={onClick}>
      <div className={styles.boxContentButton}>
        <div className={styles.iconBox}>
          <div className={styles.iconBoxContent}>{IconButtonOperation[icon]}</div>
        </div>
        <div className={styles.contentTextButton}>
          <span className={styles.titleTextButton}>{TitreButtonOperation[titre]}</span>
          <span className={styles.descriptionTextButton}>{SousTitreButtonOperation[sousTitre]}</span>
        </div>
      </div>
      {IconButtonOperation[iconFleche]}
    </button>
  );
};

export default ButtonOperation;
